import React, { useEffect, useState } from "react";
import { ASHLEY_DEBUG_ENABLED } from "./ashleyDebugConfig";
import { subscribeVoiceDiag } from "./ashleyVoiceDiagnostics";
import "./AshleyVoiceDebugPanel.css";

function formatTime(timestamp) {
  const date = new Date(timestamp);
  return date.toLocaleTimeString(undefined, {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export function AshleyVoiceDebugPanel() {
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    if (!ASHLEY_DEBUG_ENABLED) {
      return undefined;
    }
    return subscribeVoiceDiag(setSteps);
  }, []);

  if (!ASHLEY_DEBUG_ENABLED) {
    return null;
  }

  return (
    <div className="ashley-voice-debug-panel" aria-live="polite">
      <p className="ashley-voice-debug-panel__title">Ashley Voice Debug</p>
      {steps.length === 0 ? (
        <p className="ashley-voice-debug-panel__message">Waiting for interaction…</p>
      ) : (
        <ol className="ashley-voice-debug-panel__list">
        {steps.map((step, index) => (
          <li key={`${step.timestamp}-${index}`} className="ashley-voice-debug-panel__item">
            <span className="ashley-voice-debug-panel__time">
              {formatTime(step.timestamp)}
            </span>
            <span className="ashley-voice-debug-panel__message">{step.message}</span>
            {step.data?.msSinceGesture != null && (
              <span className="ashley-voice-debug-panel__meta">
                {step.data.msSinceGesture}ms since gesture
              </span>
            )}
            {step.data?.code && (
              <span className="ashley-voice-debug-panel__meta">
                code: {step.data.code}
              </span>
            )}
          </li>
        ))}
      </ol>
      )}
    </div>
  );
}
